import { Cookie as CookieNames } from '@ps/web-core-enums';
import { LoginSource } from '@ps/web-core-store';
import Cookies from 'universal-cookie';

import type { RequestError } from '@swf/core/errors/RequestError';
import type { EffectParams, RootState } from '@swf/core/store';
import { getState, select } from '@swf/core/store';

import type { AuthError } from '.';
import { loginError, loginSuccess } from './utils';

const cookies = new Cookies();

export interface RegisterPayload {
  country: string;
  email: string;
  userId: string;
  password: string;
  marketingMailList: boolean;
  age: number;
  EULA: boolean;
  state?: string;
  fiscalCode?: string;
  fiscalCodeType?: string;
  dob?: Date;
}

export const registrationRequest = async (
  request: EffectParams['request'],
  {
    country,
    state,
    email,
    userId,
    password,
    marketingMailList: mailListIn,
    fiscalCode,
    fiscalCodeType,
    dob
  }: RegisterPayload,
  rootState: RootState
) => {
  const affiliateUrl = `${rootState.location.origin}/?source=`;
  await fetch(affiliateUrl, { credentials: 'include' }).catch(() => undefined);
  const affInfo = cookies.get(CookieNames.AFFILIATE_INFO);
  const { installId } = select.session.get(rootState);
  const brand = select.cms.getBrandId(rootState);
  const { registrationBrand } = select.localSettings.get(rootState);

  return request({
    service: 'registration.ram',
    body: {
      affInfo,
      installId,
      country,
      state,
      email,
      userId,
      password,
      mailListIn,
      fiscalCode,
      fiscalCodeType,
      dob
    },
    headers: { brand: (registrationBrand || brand).toString() }
  });
};

const register = async (
  payload: RegisterPayload,
  { dispatch, request, rootState }: EffectParams
) => {
  const { marketingMailList } = payload;

  try {
    const { body, headers } = await registrationRequest(request, payload, rootState);

    await loginSuccess(
      { ...body, loginSource: LoginSource.Registration },
      { dispatch, request },
      headers
    );
    dispatch.auth.signEula({ marketingMailList, useMailList: true });

    if (!select.account.shouldOpenRmf(getState(), LoginSource.Registration)) {
      dispatch.modal.enqueue({
        path: '/auth/registration/welcome',
        locationState: { marketingMailList }
      });
    }
  } catch (err) {
    loginError(payload, err as RequestError<AuthError>, dispatch);
    dispatch.modal.replace([{ path: '/auth/registration', locationState: payload }]);
  }

  return;
};

export default register;
